
import React, { useEffect, useRef, useState } from 'react';
import { VncScreen } from 'react-vnc';
import { Container } from "react-bootstrap";
import axiosIstance from '../utils/axiosIstance';
import secureLocalStorage from 'react-secure-storage'



const  Remote = (props) => {

    console.log("viewOnly", props.ViewOnly);

    const [Refresh, setRefresh] = useState(0);
    const [ViewOnly, setViewOnly] = useState(true);
    const [compressionLevel, setcompressionLevel] = useState(0);
    const [qualityLevel, setqualityLevel] = useState(0);
    const [Con, setCon] = useState(true);
    const [Render, setRender] = useState(true);

    const ref = useRef();

    let url = "ws://remote.amesrl.it:" +  secureLocalStorage.getItem('port');
    let token = secureLocalStorage.getItem('token');
    console.log("REMOTE ===> ", url);


    if(ViewOnly != !props.ViewOnly) {
    
    }else{
      console.log("no redir needed");
    }

    useEffect( () => {

      let v = ViewOnly;
      
      if(props.PortWasOpen == true){
        setRender(true);
      }

    }, [props] );

    
    const handleDisconnect = (e) => {
      // console.log('handleDisconnect', e);  
      // setTimeout( () => {
      //   if(e?._rfbConnectionState === 'disconnected'){
      //     setCon(false);
      //   }
      // }, 1500);
    }


    const handleConnect = (e) => {
      console.log('handleConnect', e); 
      // if(e._rfbConnectionState === 'connected'){
      //   setCon(true);
      // }
    }

    return (<>
      {
        Con ? 
        <>
          {console.log("ViewOnly: " + ViewOnly)}
          {Render &&  <VncScreen
            retryDuration={1000}
            url={url} 
            background="black"
            resizeSession={true}
            scaleViewport={true}
            style={{
              width: '100%',
              height: '100%',
            }}
            ref={ref}
            onDisconnect={handleDisconnect}
            onConnect={handleConnect}
            //retryDuration={30000}
            debug={true}
            focusOnClick={false}
            viewOnly={secureLocalStorage.getItem('isC') == 1 ? false : true}
          />
          }
        </> : 
        <>
          <div style={{
              width: '100%',
              height: '100%',
            }}>
            Connection Error, Log Out Then Retry
          </div>
        </>
      }


   </>);

}

export default Remote;